module.exports = __webpack_public_path__ + "img/icon-feedback.56bb6ba8.png";